import { CatFieldset } from '@blocks-react/components/Fieldset';
import { SearchResult } from './search-result';
import { CustomerStore } from 'components/associated-dealers/types';

interface Props {
  name: string;
  searchResults: CustomerStore[];
  disabled: boolean;
}

export const SearchResults = ({ name, searchResults, disabled }: Props) => {
  return (
    <CatFieldset required={true}>
      {searchResults?.map((store, index) => {
        const isFirstValue = index === 0;
        const isLastValue = index === searchResults.length - 1;
        return (
          <SearchResult
            name={name}
            key={store.customerNumber}
            store={store}
            isFirstValue={isFirstValue}
            isLastValue={isLastValue}
            disabled={disabled}
          />
        );
      })}
    </CatFieldset>
  );
};
